import { render, staticRenderFns } from "./PostQuiz.vue?vue&type=template&id=8fb9f332&scoped=true&"
import script from "./PostQuiz.vue?vue&type=script&lang=js&"
export * from "./PostQuiz.vue?vue&type=script&lang=js&"
import style0 from "./PostQuiz.vue?vue&type=style&index=0&id=8fb9f332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb9f332",
  null
  
)

export default component.exports